var r=function(r){return!0};export{r as isGuildTheme};
